import {BaseContainerModel} from "../../base-container.model";
import {bl_wf_project_user_RowClass} from "../../../dbschema/bl_wf_project_user_link.model";

export class WfProjectUserContainerModel extends BaseContainerModel {
  bl_wf_project_user_link: bl_wf_project_user_RowClass = new bl_wf_project_user_RowClass();
}
